import { Fragment } from "react";

const ITEMS = ["IDEAS", "ACTION", "IMPACT"];

function Group({ hidden = false }) {
    return (
        <div
            className="flex shrink-0 items-center"
            aria-hidden={hidden || undefined}
        >
            {ITEMS.map((item, i) => (
                <Fragment key={i}>
                    <span className="font-display text-2xl md:text-4xl tracking-tight px-8 md:px-14">
                        {item}
                    </span>
                    <span className="h-2.5 w-2.5 rotate-45 bg-sage" />
                </Fragment>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div
            className="overflow-hidden border-y border-line py-6 md:py-8"
            data-testid="marquee-strip"
        >
            <div className="marquee-track flex w-max">
                <Group />
                <Group hidden />
            </div>
        </div>
    );
}
